import { render, staticRenderFns } from "./Pane.vue?vue&type=template&id=72ac2817&scoped=true"
import script from "./Pane.vue?vue&type=script&lang=js"
export * from "./Pane.vue?vue&type=script&lang=js"
import style0 from "./Pane.vue?vue&type=style&index=0&id=72ac2817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac2817",
  null
  
)

export default component.exports